import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba58872"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qrcode" }
const _hoisted_2 = { class: "scan-qr" }
const _hoisted_3 = {
  key: 1,
  class: "qr-loader"
}

import customerService from '@/services/customer-service'
import { IonSpinner } from '@ionic/vue'
import { onMounted, ref } from 'vue'
import VueQrCode from '@chenfengyuan/vue-qrcode'


export default /*#__PURE__*/_defineComponent({
  __name: 'QrCodeModal',
  setup(__props) {

const localQrCode = ref('')
const loadingQr = ref(true)

onMounted(() => {
  getQrToken()
})

const getQrToken = async () => {
  loadingQr.value = true
  const { qrCode } = await customerService.getQrCode()
  localQrCode.value = qrCode
  loadingQr.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('store.scanQr')), 1),
    (localQrCode.value && !loadingQr.value)
      ? (_openBlock(), _createBlock(_unref(VueQrCode), {
          key: 0,
          value: localQrCode.value,
          tag: "svg",
          options: {
        color: {
          dark: '#1A1A1A'
        },
        width: 200,
        height: 200,
        margin: 0
      },
          onClick: getQrToken
        }, null, 8, ["value"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(IonSpinner), { name: "crescent" })
        ]))
  ]))
}
}

})